import React from "react";
import { Box, Grid, Rating, Stack } from "@mui/material";
import LandingHeader from "../../../layout/header";
import Footer from "../../../layout/footer";
import { BlueBox, BtnAccess, ReviewBox } from "../style";
import { RootStyle, Text, Title } from "../style";
import { AboutGrid, AboutText, AboutTitle } from "../style";
import AboutImg from "../../../images/landing/store module.png";
import Icon1 from "../../../images/landing/store icon 1.png";
import Icon2 from "../../../images/landing/store icon 2.png";
import Icon3 from "../../../images/landing/delivery icon 3.png";
import PartnerLogo from "../../../images/landing/sheikh.png";
import { Link } from "react-router-dom";
import AccessNow from "../AccessNow";
import { InnerBlueBox } from "../style";

function StoreModule() {
  return (
    <Box sx={{ background: "#fff" }}>
      <LandingHeader />
      <RootStyle sx={{ my: "40px" }}>
        <Stack spacing="64px">
          <BlueBox sx={{ minHeight: "163px" }}>
            <InnerBlueBox sx={{ p: "0 0 0 32px", maxHeight: "163px" }}>
              <Grid container>
                <AboutGrid item md={7} xs={12}>
                  <AboutTitle>E-Commerce Store</AboutTitle>
                  <Link to="/inventory/login">
                    <BtnAccess>Access Now</BtnAccess>
                  </Link>
                </AboutGrid>
                <Grid item md={5} xs={12} sx={{ order: { xs: 1, md: 2 } }}>
                  <Box>
                    <img
                      style={{ maxHeight: "163px" }}
                      width="100%"
                      src={AboutImg}
                      alt=""
                    />
                  </Box>
                </Grid>
              </Grid>
            </InnerBlueBox>
          </BlueBox>

          <Stack spacing="40px" alignItems="center">
            <AboutTitle sx={{ color: "#60656C", textAlign: "center" }}>
              Make your own E-Commerce store with ManageKaro !
            </AboutTitle>
            <img src={Icon1} alt="" />
          </Stack>

          <Box
            sx={{
              background: "#FBFFED",
              p: "64px 32px ",
              borderRadius: "24px",
            }}
          >
            <Grid container spacing="32px">
              <Grid item md={8} xs={12} order={{ xs: 2, md: 1 }}>
                <AboutText>Key Features:</AboutText>
                <ul>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Seamless Online Ordering: </b> Transform your website
                      into a powerful online storefront. Enable customers to
                      browse, order, and pay effortlessly with our user-friendly
                      platform.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Boost Sales:</b> Reach a wider audience and increase
                      sales with your personalized eCommerce store. Showcase
                      your products, highlight promotions, and entice customers
                      with a seamless shopping experience.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Order Tracking Made Easy:</b>Keep both you and your
                      customers in the loop with real-time order tracking. From
                      processing to shipping, stay informed at every stage of
                      the journey.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Effortless Inventory Management:</b>Update your product
                      catalog, manage stock levels, and add new items with just
                      a few clicks. No more guesswork – know exactly what you
                      have and what you need.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Delivery Management:</b>Track deliveries in real-time
                      and provide accurate delivery estimates to your customers.
                      Stay on top of your fulfillment process with ManageKaro.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Mark Orders as Deliverd:</b>Once the order reaches its
                      destination, easily mark it as delivered in your
                      dashboard. Streamline your post-purchase process and
                      enhance customer satisfaction.
                    </AboutText>
                  </li>
                </ul>
              </Grid>
              <Grid item md={4} xs={12} order={{ xs: 1, md: 2 }}>
                <img width="100%" src={Icon2} alt="" />
              </Grid>
            </Grid>
          </Box>

          <Stack spacing="40px" alignItems="center">
            <AboutTitle
              sx={{
                color: "#60656C",
                textAlign: "center",
                fontWeight: 500,
                fontSize: "20px",
              }}
            >
              Elevate your business today with ManageKaro's e-commerce solution.
              Get ready for a new era of online success!
            </AboutTitle>
          </Stack>

          <ReviewBox>
            <Grid container spacing="16px">
              <Grid
                item
                md={6}
                xs={12}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Stack>
                  <Text sx={{ color: "#fff" }}>
                    “The delivery management and gatepass features of ManageKaro
                    have transformed the way we handle our operations. One of
                    the standout benefits is the automated gatepass generation.
                    We've bid farewell to manual paperwork, reducing the chances
                    of errors and ensuring a seamless flow in our delivery
                    processes.Real-time tracking has become a game-changer for
                    us. With ManageKaro, we can monitor the status of every
                    gatepass and delivery in real-time. This level of visibility
                    enables us to proactively manage our deliveries, promptly
                    address any issues, and enhance overall efficiency.”
                  </Text>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "center", md: "flex-start" },
                    }}
                  >
                    <Rating name="simple-controlled" value={5} />
                  </Box>
                </Stack>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={PartnerLogo} alt="" />
                  <Box>
                    <Title sx={{ color: "#fff" }}>Sheikh Stationay</Title>
                    <Title sx={{ color: "#fff", fontSize: "24px" }}>
                      Mr Waleed
                    </Title>
                    <Text sx={{ color: "#fff", fontStyle: "italic" }}>
                      Mohan Pura, Near Afzal Food Point, Novelty Cinema,
                      Rawalpindi
                    </Text>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </ReviewBox>

          <AccessNow />
        </Stack>
      </RootStyle>
      <Footer />
    </Box>
  );
}

export default StoreModule;
